export interface CheckLendCollectionListRequestCollection {
  id: number
  dueDate: string
  handlingType: string
  shelfType: string
  _deleteHandlingType: boolean
}

export function CheckLendCollectionListRequestCollectionToJSON(
  value: CheckLendCollectionListRequestCollection
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    due_date: value.dueDate !== '' ? value.dueDate : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    _delete_handling_type: value._deleteHandlingType ?? undefined
  }
}
